import React from "react";
import { Route } from "react-router-dom";
import { useAuth } from "../AuthenticationStore";
import { Login } from "../views/pages/Login";
import SplashScreen from "./ui/SplashScreen";
import { Welcome } from "../views/pages/Home/Welcome";

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated, loading, isNewUser } = useAuth();

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <Route
      {...rest}
      render={props => {
        return isAuthenticated ? (
          isNewUser ? (
            <Welcome />
          ) : (
            <Component {...props} />
          )
        ) : (
          <Route component={Login} />
        );
      }}
    />
  );
};
